import {AxiosServer, AxiosEsb,ArrRemoveSubItem} from '../../utils';
import {message} from 'antd';
import {server} from "../../config";

let namespace = 'purloanafter_';

//直接dispatch 为同步方法，比如  dispatch({type:'login/set',payload:{loading:false}});
//store 使用了thunk中间件，以下方法均为异步加载。

const purLoanAfterAc = {
	SET:(value) =>(dispatch,getState)=>{
		dispatch({type: namespace+'forcedUpdate', payload: value})},		

	GET:(value)=>(dispatch,getState)=>{
		let store =getState().purLoanAfterRd;
		let {dataFetchProps,searchProps,pagination} =store;
		let {current:currentPage,pageSize} =pagination;
		dataFetchProps ={...dataFetchProps,...searchProps,...value,currentPage,pageSize}
		let Axios = AxiosServer();		

		return Axios.post('/purAfterLoan/findAll',dataFetchProps).then((res)=>{
			if (res.data.status == true){
				pagination ={...pagination,total:res.data.count}
				dispatch({type: namespace+'forcedUpdate', payload: {data:res.data.data, pagination:pagination,dataLoading: false,opentype: false}}); // 翻页的时候，先更新 dataLoading: true
				return '刷新成功'
			}else{
				dispatch({type: namespace+'forcedUpdate', payload: {dataLoading: false}}); 
				return '刷新失败'
			}
			
		}).catch((err)=>{
			message.error('purLoanAfter ' + err,10);
			dispatch({type: namespace+'forcedUpdate', payload: {dataLoading: false}}); 
			return '错误'
	})
	},		
	
	

	
	UPDATE:(value, selectedRowIndex = null)=>(dispatch,getState)=>{
		//可以多次dispatch(), value 是传过来的参数,  getState() 可获取当前store的状态	
		//dispatch({type:'login/set',payload:{loading:true}});
		//value 是传过来的参数
		//getState 可获取当前store的状态
		//强转id为数字，规免出错
		let id = parseInt(value.id);			
		
		let Axios = AxiosServer();
		return  Axios.post('/purAfterLoan/update',value).then((res)=>{
		
			if (res.data.status){
				//更新成功，重新获取数据			
				dispatch({type: namespace+'forcedUpdate', payload: {dataLoading: true}}); 
				return '更新成功'
			}
			return '更新失败'
			
		}).catch((err)=>{
			//dispatch({type:'login/set',payload:{loading:false}});
			console.log('err:',err);
			return 'error'
		})
	},

	LOANAFTERSENDTOSFTP:(value,record, data = null)=>(dispatch,getState)=>{

		let json ={item:value,code_list:record,ruleData:data}

		let Axios = AxiosEsb();
		return  Axios.post('/api/towxsbank/purLoanAfter/sendToSftp',json).then((res)=>{

			if (res.data.status){
				//更新成功，重新获取数据
				dispatch({type: namespace+'forcedUpdate', payload: {dataLoading: true}});
				return '更新成功'
			}
			return '更新失败'

		}).catch((err)=>{
			//dispatch({type:'login/set',payload:{loading:false}});
			console.log('err:',err);
			return 'error'
		})
	},

	PURAFTERPATCHSFTP:(value,record, data = null)=>(dispatch,getState)=>{

		let json ={item:value,code_list:record,ruleData:data}

		let Axios = AxiosEsb();
		return  Axios.post('/api/towxsbank/purAfterPatch/sendToSftp',json).then((res)=>{

			if (res.data.status){
				//更新成功，重新获取数据
				dispatch({type: namespace+'forcedUpdate', payload: {dataLoading: true}});
				return '更新成功'
			}
			return '更新失败'

		}).catch((err)=>{
			//dispatch({type:'login/set',payload:{loading:false}});
			console.log('err:',err);
			return 'error'
		})
	},

	PUSHPROJECTLOAPOSTVALUEOTCG:(value)=>(dispatch,getState)=>{



		let Axios = AxiosEsb();
		return  Axios.post('/api/towxsbank/pushProjectLoaPostValueOtcg',value).then((res)=>{

			if (res.data.status){
				//更新成功，重新获取数据
				dispatch({type: namespace+'forcedUpdate', payload: {dataLoading: true}});
				return '推送成功';
			}
			return res.data.msg;

		}).catch((err)=>{
			//dispatch({type:'login/set',payload:{loading:false}});
			console.log('err:',err);
			return 'error'
		})
	},

	PUSHSUPPLYMATERIALOTCG:(value)=>(dispatch,getState)=>{



		let Axios = AxiosEsb();
		return  Axios.post('/api/towxsbank/loanPostSupplyMaterialOtcg',value).then((res)=>{

			if (res.data.status){
				//更新成功，重新获取数据
				dispatch({type: namespace+'forcedUpdate', payload: {dataLoading: true}});
				return '推送成功';
			}
			return res.data.msg;

		}).catch((err)=>{
			//dispatch({type:'login/set',payload:{loading:false}});
			console.log('err:',err);
			return 'error'
		})
	},

}


export {purLoanAfterAc};